import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  provideAsWidgetRef,
  Parent,
  register,
  styler
} from "@wm/components-base";
import {DatasetAwareNavComponent} from "../menu/nav/dataset-aware-nav.component";

const DEFAULT_CLS = 'breadcrumb app-breadcrumb';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-breadcrumb',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmBreadcrumb]',
  template: `<li *ngFor="let item of nodes; let last = last; let index = index" [ngClass]="{active: last}" class="{{item.class}}">
    <i class="{{item.icon}}"></i>
    <a [title]="item.label" href="javascript:void(0)"  *ngIf="!last" [textContent]="item.label"></a>
    <label *ngIf="last" [textContent]="item.label"></label>
  </li>`,
  providers: [
    provideAsWidgetRef(BreadcrumbComponent)
  ],
  exportAs: 'wmBreadcrumb',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class BreadcrumbComponent extends DatasetAwareNavComponent {
  static initializeProps = register('wm-breadcrumb');
  override defaultNodes: any = 'Home, Page'
  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    var dataset = this.dataset || {};
    switch (key) {
      //break statement is intentionally removed for the flow
      case 'itemicon':
      case 'itemclass':
      case 'itemlabel':
      case 'itemlink':
      case 'itemid':
      case 'itemchildren':
        // scope.nodes = getNodes(scope, dataset.data || dataset);
        break;
    }
    super.onPropertyChange(key, nv, ov);
  }

}

